import { Route } from 'react-router-dom';
import { lazyWithRetry } from 'components/lazyWithRetry';

const ComponentList = lazyWithRetry(() => import('modules/admin/event/componentList'));
const LearnerList = lazyWithRetry(() => import('modules/admin/event/learnerList'));

export default (
  <>
    <Route
      path="event"
      element={<ComponentList />}
    />
    <Route
      path="event/:eventId"
      element={<LearnerList />}
    />
  </>
);
